import { Spin, Text } from "@/atoms"
import { SettingOutlined } from "@/icons"

import type { TitleItemProps } from "."

export const TitleItem = ({
  title,
  className,
  Icon = SettingOutlined,
  loading
}: TitleItemProps) => (
  <li className={className} tabIndex={0}>
    <Icon />
    <Text className="capitalize-text-ks">{title}</Text>
    {loading && <Spin size="small" />}
  </li>
)
